<app-modal>
  <div class="modal-l">
    <app-modal-content>
      <div class="modal-body self-registration-modal__body">
        <iframe [src]="url()"></iframe>
      </div>
    </app-modal-content>

    <app-modal-footer>
      <div class="modal-footer self-registration-modal__footer">
        <app-button (clickEvent)="close()">
          {{ 'CLOSE_A' | translate }}</app-button
        >
      </div>
    </app-modal-footer>
  </div>
</app-modal>
